"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _radio = _interopRequireDefault(require("britive-design-system/core/components/radio"));

var _tooltip = _interopRequireDefault(require("britive-design-system/core/components/tooltip"));

var _constants = require("./constants");

var _infoIcon = _interopRequireDefault(require("../../../../../assets/infoIcon.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.policy-step-up-verification-tab-main-container {\n  flex-grow: 1;\n  padding-top: 3rem;\n  padding-left: 3.5rem;\n  padding-bottom: 3rem;\n  padding-right: 2rem;\n  overflow: auto; }\n  .policy-step-up-verification-tab-main-container::-webkit-scrollbar {\n    width: 0.5rem;\n    height: 0.5rem; }\n  .policy-step-up-verification-tab-main-container::-webkit-scrollbar-track {\n    border-radius: 0.5rem;\n    margin-top: 0.125rem; }\n  .policy-step-up-verification-tab-main-container::-webkit-scrollbar-thumb {\n    border-radius: 0.5rem;\n    background-color: #c6c6c6; }\n  .policy-step-up-verification-tab-main-container::-webkit-scrollbar-thumb:hover {\n    background-color: #6f6f6f; }\n  .policy-step-up-verification-tab-main-container .sm-add-policy-field-wrapper {\n    margin-bottom: 2rem; }\n  .policy-step-up-verification-tab-main-container .always-prompt-info-icon-wrapper {\n    display: inline;\n    margin-left: 0.125rem; }\n    .policy-step-up-verification-tab-main-container .always-prompt-info-icon-wrapper img {\n      height: 1.125rem; }\n";
  var fileName = "compone_stepUpVerification";
  var element = document.querySelector("style[data-sass-component='compone_stepUpVerification']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var StepUpVerification = function StepUpVerification(_ref) {
  var validationHook = _ref.validationHook,
      translatedStrings = _ref.translatedStrings;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.stepperMainContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement(_radio.default, {
    defaultValue: "".concat(validationHook.values.stepUpVerificationEnabled),
    direction: "vertical",
    label: translatedStrings.stepUpVerificationEnable,
    name: "stepUpVerificationEnabled",
    options: _constants.stepUpConditionData,
    onChange: function onChange(e) {
      var value = e.target.value;
      validationHook.handleChange(validationHook.names.stepUpVerificationEnabled, value === 'true');

      if (value !== 'true') {
        validationHook.handleChange(validationHook.names.stepUpVerificationAlwaysPrompt, false);
      }
    }
  })), validationHook.values.stepUpVerificationEnabled && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement(_radio.default, {
    defaultValue: "".concat(validationHook.values.stepUpVerificationAlwaysPrompt),
    direction: "vertical",
    label: /*#__PURE__*/_react.default.createElement("div", null, translatedStrings.stepUpVerificationAlwaysPrompt, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      title: translatedStrings.stepUpVerificationAlwaysPromptTooltip,
      position: "top"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes.alwaysPromptInfoIcon
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: _infoIcon.default
    })))),
    name: "stepUpVerificationAlwaysPrompt",
    options: _constants.alwaysPromptData,
    onChange: function onChange(e) {
      return validationHook.handleChange(validationHook.names.stepUpVerificationAlwaysPrompt, e.target.value === 'true');
    }
  })));
};

StepUpVerification.propTypes = {
  validationHook: _propTypes.default.object,
  translatedStrings: _propTypes.default.object
};
var _default = StepUpVerification;
exports.default = _default;